/* exposes utilities and scoring functions
 * on the window for debugging purposes */
import type { Fnode } from "@protontech/fathom";

import * as clustering from "./utils/clustering";
import * as dom from "./utils/dom";
import * as exclusions from "./utils/exclusion";
import * as extract from "./utils/extract";
import * as fields from "./utils/field";
import * as forms from "./utils/form";
import * as prepass from "./utils/prepass";
import * as visibility from "./utils/visible";

declare global {
  interface Window {
    FATHOM_DEBUG?: {
      createMockFnode: (element: HTMLElement) => Fnode;
      clustering: typeof clustering;
      dom: typeof dom;
      exclusions: typeof exclusions;
      extract: typeof extract;
      fields: typeof fields;
      forms: typeof forms;
      prepass: typeof prepass;
      visibility: typeof visibility;
    };
  }
}

window.FATHOM_DEBUG = {
  createMockFnode: (element: HTMLElement) => ({ element }) as Fnode,
  clustering,
  dom,
  exclusions,
  extract,
  fields,
  forms,
  prepass,
  visibility,
};
